export interface ReadCssVariableParams {
  variableName: string;
  element?: HTMLElement;
}

export const readCssVariable = ({variableName, element = document.body}: ReadCssVariableParams) => {
  const styles = window.getComputedStyle(element);

  // Read the value of the CSS variable
  const variableValue = styles.getPropertyValue(variableName);

  return variableValue;
}
